// extracted by mini-css-extract-plugin
export default {"root":"tMP2ux","alignmentWrapper":"ICGtQ9"};